// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.cypherwallet",
    name: "Cypher Wallet",
    homepage: "https://cypherwallet.io",
    image_id: "7bce0965-a4cc-4aad-6217-009d51017500",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/cypherd-wallet/id1604120414",
        android: "https://play.google.com/store/apps/details?id=com.cypherd.androidwallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/cypher-wallet/niiaamnmgebpeejeemoifgdndgeaekhe",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "cypherwallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map